import { queryOptions } from '@tanstack/react-query';

import { apiReferralFetch } from '..';
import { IntroducerMembership } from './types';

export const REFERRAL_QUERY_KEYS = {
  introducerMembership: 'referralIntroducerMembership',
  pendingIntroducerInvitations: 'referralPendingIntroducerInvitations',
};

export const introducerMembershipQueryKey = (userId?: string) => [
  REFERRAL_QUERY_KEYS.introducerMembership,
  userId,
];

export const _getIntroducerMembership = (userId?: string) => {
  return queryOptions({
    enabled: !!userId,
    queryKey: introducerMembershipQueryKey(userId),
    queryFn: () =>
      apiReferralFetch<IntroducerMembership>(`/admin/introducers/${userId}/membership`),
    refetchOnMount: true,
    retry: 1,
  });
};
